import {PopupData} from "@/intefaces/popup.prop";
import {Htag} from "./ui/htag";
import {Button} from "./ui/button";
import {P} from "@/components/ui/P";
import {Icon} from "@/components/ui/icon";
import Link from "next/link";
import SimplePhoneForm from "@/components/form-only-phone";
import React from "react";
import {X} from "lucide-react";
interface PopupProps {
    data: PopupData;
    isOpen: boolean;
    onClose: () => void;
}

export const Popup = ({isOpen, onClose, data}: PopupProps) => {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4"
            onClick={onClose}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="relative w-full max-w-lg bg-white rounded-2xl shadow-xl p-6 lg:p-8 transform transition-all duration-300 scale-100"
            >
                {/* Кнопка закрытия */}
                <Button
                    onClick={onClose}
                    size="icon"
                    className="absolute top-4 right-4 text-gray-400 hover:text-primary transition-colors"
                    variant="ghost"
                >
                    <X color={'black'} className={' border-2 border-black rounded-full'}/>
                    {/*<Icon path="/close.svg" size="m" alt="Закрыть" />*/}
                </Button>

                {/* Заголовок и текст */}
                <div className="flex flex-col gap-3 text-left">
                    <Htag tag={'h1'} className="max-w-[400px]">
                        {data.discription}
                    </Htag>

                    <P  className="text-sm text-gray-600 border border-gray-100 p-3 rounded-xl bg-gray-200">
                        {data.title}
                    </P>
                </div>

                {/* Телефон */}
                <div className="mt-4 flex items-center gap-3 text-primary text-base font-medium">
                    <Icon
                        path="/call3.svg"
                        size="l"
                        alt="Позвонить"
                        className="border border-secondary rounded-full h-8 w-8 p-1"
                    />
                    <Link href="tel:+79113007705" className="text-sm hover:underline">
                        +7 (8152) 707-705
                    </Link>
                </div>

                {/* Форма */}
                <SimplePhoneForm className="mt-6" />

                {/* Политика */}
                <p className="mt-4 text-xs text-gray-400 leading-snug">
                    Отправляя заявку, вы соглашаетесь с{" "}
                    <Link href="/privacy" className="underline text-gray-500 hover:text-primary">
                        политикой конфиденциальности
                    </Link>
                    .
                </p>
            </div>
        </div>
    );
};
